const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, string>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, ns] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = {};
    }

    // 优先取 default export，没有则取第一个对象类型的命名导出
    let data: Record<string, string> | undefined;
    if (module.default && typeof module.default === 'object' && module.default !== null) {
      data = module.default as Record<string, string>;
    } else {
      const namedExport = Object.values(module).find(
        (v) => v !== null && typeof v === 'object' && !Array.isArray(v)
      );
      if (namedExport) {
        data = namedExport as Record<string, string>;
      }
    }

    if (data) {
      messages[lang][ns] = data;
    }
  }
});

export default messages;